import { getAppStore } from '@/store';

import type { AnalyticsSettings } from './analyticsSettings';

/**
 * Settings payload for upload events. `category` is the active tab slug and `id`
 * is the active preset slug — both read from the store so the shared upload
 * stack doesn't have to carry them through its interface.
 */
const getUploadAnalyticsSettings = (): AnalyticsSettings => {
  const { activeTabSlug, selectedPreset } = getAppStore();

  return {
    category: activeTabSlug ?? '',
    id: selectedPreset?.slug ?? '',
  };
};

export default getUploadAnalyticsSettings;
